/* import __COLOCATED_TEMPLATE__ from './seller-posting-section.hbs'; */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';

/** @module */
const SellerPostingSectionComponent = Component.extend({
  /** @inheritDoc */
  tagName: 'section',

  /** @inheritDoc */
  classNames: ['seller-posting-section'],

  /** @type {string} */
  title: '',

  /** @type {string} */
  content: '',

  /** @inheritDoc */
  classNameBindings: [
    'isLeft:seller-posting-section--left',
    'isRight:seller-posting-section--right',
  ],

  /** @type {left|right|undefined} */
  position: undefined,

  /** @type {Ember.ComputedProperty} */
  isLeft: equal('position', 'left'),

  /** @type {Ember.ComputedProperty} */
  isRight: equal('position', 'right'),
});

export default SellerPostingSectionComponent;
